import React,{Component} from 'react';
import { IonRouterLink, IonLoading } from '@ionic/react';

import './Login.css';

// Redux
import {connect} from 'react-redux';

// components

// methods
import { loginBackground, logo } from '../../_utils/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../_utils/routes';
import Message from '@acri-tools/react-tools/components/Message/Message';
import { login } from '@acri-tools/react-tools/utils/login';
import { go_back, push_history } from '@acri-tools/react-tools/utils/global';

interface MyProps{
    history?:any,
    // setToasts?:any
}

class Login extends Component<MyProps,{}>{
    state={
        email:'',
        password:'',
        loggingIn:false,
        hasEntered:false,
        message: '',
        messageType: 'error'
    }
    render(){
        return (
            <Page 
                id="login" 
                topBar={{
                    routes: routes,
                    logo: logo,
                }}
            >
                <IonLoading
                    isOpen={this.state.loggingIn}
                    message={'Logging In...'}
                />
                <div 
                    className="page-content"
                    style={{
                        backgroundImage:`url(${loginBackground})`
                    }}
                >
                    <div id="login-container" className="form-container">
                        <div className="form">
                            <div className="form-field large">
                                <label>
                                    {/* <i  className="far fa-envelope" /> */}
                                    Email - Username
                                </label>
                                <input 
                                    type="email" value={this.state.email} placeholder={"Email - Username"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({email:e.target.value}); }}/>
                            </div>
                            <div className="form-field large">
                                <label>
                                    {/* <i  className="far fa-key" /> */}
                                    Password
                                </label>
                                <input 
                                    type="password" value={this.state.password}  placeholder={"Password"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({password:e.target.value}); }}/>
                            </div>
                            
                            <Message message={ this.state.message } type={ this.state.messageType }/>
                            
                        </div>
                        
                        <br/>
                        <IonRouterLink className="custom-link" routerLink='/forgot-password'><i className="fas fa-question-circle"/> Forgot Password</IonRouterLink>
                        <br/>

                        <div className="custom-button login" onClick={this.login}>LOGIN</div>
                        {/* <h2 className="divider"><div className="line"/><span>OR CONNECT WITH</span><div className="line"/></h2>
                        <div className="login-alt">
                            <div className="custom-button inverted alt google" onClick={this.loginGoogle}>
                                <i className="fab fa-google"/>
                                GOOGLE
                            </div>
                            <div className="custom-button inverted alt linkedin" onClick={this.loginLinkedin}>
                                <i className="fab fa-linkedin"/>
                                LINKEDIN
                            </div>
                        </div> */}
                    </div>  
                </div>
            </Page>
        );
    }

    inputTyped = () =>{
        this.setState({
            message: ''
        })
    }
    onEnter = (e:any) =>{
        if(e.keyCode === 13){
            this.login();
        }
    }

    loginGoogle = async() =>{}
    loginLinkedin = async() =>{}
    login = async() =>{
        if(!this.state.email){
            this.setState({
                message: 'Missing Username or Email',
                messageType: 'warn'
            })
            // this.props.setToasts({alert:true,alertMessage:`Username and password are required.`,alertHeader:"Warning"});
        }
        else if(!this.state.password){
            this.setState({
                message: 'Missing Password',
                messageType: 'warn'
            })
        }
        else{
            this.setState({loggingIn:true});
            
            let login_status = await login(true,this.state.email,this.state.password);
            this.setState({ loggingIn:false });
            if(login_status.success){
                // go_back();
            }
            else{
                this.setState({
                    message: login_status.error ? login_status.error : '',
                    messageType: 'error'
                })
            }
        }
    }
};

const mapStateToProps = (state:any) =>{
    return {
        login : state.login
    }
}

export default connect(mapStateToProps)(Login);
